module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-304.c950d01.woff2";